import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import '~/utils/initLocale';
import RequestStore from './stores/request';
import App from './routes';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider RequestStore={RequestStore}>
    <App />
  </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
